(() => {
  const titleSelector = ".product-grid-item__title";
  const toggleSelector = ".product-grid-item__title-toggle";
  const mobileQuery = window.matchMedia("(max-width: 749px)");

  const updateToggleVisibility = (title) => {
    const toggle = title.parentElement.querySelector(toggleSelector);
    if (!toggle) return;

    if (!mobileQuery.matches) {
      title.classList.remove("is-expanded");
      toggle.setAttribute("aria-expanded", "false");
      toggle.textContent = toggle.dataset.showMore;
      toggle.hidden = true;
      return;
    }

    const isExpanded = title.classList.contains("is-expanded");
    const isTruncated = title.scrollHeight > title.clientHeight + 1;
    toggle.hidden = !mobileQuery.matches || (!isExpanded && !isTruncated);
  };

  const updateAllToggleVisibility = () => {
    document.querySelectorAll(titleSelector).forEach(updateToggleVisibility);
  };

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest(toggleSelector);
    if (!toggle) return;

    const title = toggle.parentElement.querySelector(titleSelector);
    if (!title) return;

    const isExpanded = title.classList.toggle("is-expanded");
    toggle.setAttribute("aria-expanded", String(isExpanded));
    toggle.textContent = isExpanded ? toggle.dataset.showLess : toggle.dataset.showMore;
    updateToggleVisibility(title);
  });

  window.addEventListener("resize", updateAllToggleVisibility);
  updateAllToggleVisibility();
  if (document.fonts?.ready) {
    document.fonts.ready.then(updateAllToggleVisibility);
  }
})();
